import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=59cead54&scoped=true&"
import script from "./Alerts.vue?vue&type=script&lang=ts&"
export * from "./Alerts.vue?vue&type=script&lang=ts&"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=59cead54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cead54",
  null
  
)

export default component.exports